import * as setup from './datatables_setup';

$(function () {
  $('#submitter-users-table-admin').DataTable({
    processing: true,
    language: {
      lengthMenu: "Show _MENU_ entries",
      processing: setup.tableStartProcessing(),
      emptyTable: "No data available in table"
    },
    drawCallback: function() {
      setup.tableStopProcessing();
    },
    serverSide: true,
    ajax: {
      url: $('#submitter-users-table-admin').data('source'),
      dataSrc: 'data'
    },
    pagingType: "simple_numbers",
    stateSave: true,
    columnDefs: [
      {
        orderable: false,
        targets: [3, 6, 7, 8]
      },
      {
        width: "10%",
        targets: [8]
      },
      {
        width: "120px",
        targets: [5]
      }
    ],
  });
});